import { defineStore } from 'pinia'

import { ref } from 'vue'
import { formatYMD, getTemplateData } from '@/utils'
import type { GiftProperties } from '@/types/recharge/gifts'
import type { Product, Variant } from '@/types/shopify'

const resetProperties = () => ({
  '__rc_gift_recipient_first_name': '',
  '__rc_gift_recipient_last_name': '',
  '__rc_gift_recipient_email': '',
  '__rc_gift_recipient_note': '',
  '__rc_gift_sender_name': '',
  '__rc_gift_sender_email': ''
})

export const useGiftCreateStore = defineStore('gift-create', () => {
  const product = getTemplateData<Product>('#json-product')
  const variant = ref<Variant | undefined>()

  const showForm = ref(false)
  const scheduledAt = ref<Date>()
  const properties = ref<GiftProperties>(resetProperties())

  const buildGiftItem = () => {
    const { value: vari } = variant
    const { value: props } = properties

    if (!vari || !props) {
      throw new Error('could not create gift')
    }

    if (scheduledAt.value) {
      props['__rc_gift_notification_scheduled_at'] = formatYMD(scheduledAt.value)
    }

    return {
      id: vari.id,
      sku: vari.sku,
      quantity: 1,
      properties: props
    }
  }

  const reset = () => {
    properties.value = resetProperties()
    scheduledAt.value = undefined
    showForm.value = false
  }

  return {
    scheduledAt,
    showForm,
    product,
    variant,
    properties,
    buildGiftItem,
    reset
  }
})
